var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getTestId, isValidObject } from '@airtel/air-design-system';
import { View } from 'react-native';
import { SectionHeader1Widget } from '../section-header1-widget';
import { getHeroLobWidgetStyles } from './HeroLobWidgetStyles';
import { PropositionCardsCarousel } from './components/proposition-cards/';
import { WithQAB } from './components/withQab';
export var HeroLobWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'HeroLobWidgetContainer' : _props$testID,
    style = props.style,
    type = props.type,
    sectionProps = props.sectionProps,
    propositionCardProps = props.propositionCardProps,
    onUserAction = props.onUserAction,
    id = props.id,
    restProps = __rest(props, ["testID", "style", "type", "sectionProps", "propositionCardProps", "onUserAction", "id"]);
  var hereLobWidgetStyles = getHeroLobWidgetStyles();
  var updatedSectionProps = Object.assign(Object.assign({}, sectionProps), {
    style: [hereLobWidgetStyles.sectionHeaderPadding, sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.style]
  });
  return _jsx(_Fragment, {
    children: _jsxs(View, Object.assign({}, getTestId(testID), {
      style: [hereLobWidgetStyles.container, style]
    }, {
      children: [isValidObject(sectionProps) && _jsx(SectionHeader1Widget, Object.assign({}, getTestId(testID, 'SectionHeader'), updatedSectionProps)), type === 'qab' && _jsx(WithQAB, Object.assign({}, props)), type === 'propositionCards' && _jsx(PropositionCardsCarousel, Object.assign({}, restProps, propositionCardProps, {
        onUserAction: onUserAction
      }, getTestId(testID, 'PropositionCards'), {
        id: id
      }))]
    }))
  });
};
HeroLobWidgetComponent.genericRendererKey = 'AirHeroLobWidget';